export * from './src/email-marketing-v1-sender-details-sender-details.meta.js';
